import { z } from 'zod'

// Zod's `new Function` JIT probe trips CSP violation reports in every browser
// session (https://github.com/colinhacks/zod/issues/5789). Lives in this package
// so the call reaches the zod v4 instance the workspace packages share — web-ui's
// own `zod` resolves to v3, whose config would not affect it.
//
// Deliberately plain ESM `.js` (with a hand-written `.d.ts` sibling): web-ui's
// instrumentation-client webpack entry has no TS loader for workspace source,
// and shipping JS avoids the `transpilePackages` workaround entirely. See
// "instrumentation-client.ts workspace imports" in the root discoveries.md.
//
// Once web-ui is on zod v4, call z.config({ jitless: true }) from 'zod' in
// instrumentation-client.ts directly and delete this file and its `.d.ts`.
export function enableZodJitless() {
  z.config({ jitless: true })
}
